import React from 'react';
import { designSystem } from '@yola/ws-ui';
import PropTypes from 'prop-types';

const { Box, Stack, Heading } = designSystem;

function Section({ children, title }) {
  return (
    <Box
      paddingTop="spacing-xs"
      paddingBottom="spacing-s"
      paddingLeft="spacing-m"
      paddingRight="spacing-m"
    >
      <Stack gap="spacing-2-xs">
        <Heading type="heading-6" singleLine>
          {title}
        </Heading>
        {children}
      </Stack>
    </Box>
  );
}

Section.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
};

export default Section;
